import { lazyRetry } from './retry';
const Home = lazyRetry(() => import(/* webpackChunkName: "Home" */ 'pages/Home'));
const Catalog = lazyRetry(() => import(/* webpackChunkName: "Catalog", webpackPrefetch: true */ 'pages/Catalog'));
const Product = lazyRetry(() => import(/* webpackChunkName: "Product", webpackPrefetch: true */ 'pages/Product'));
const Localities = lazyRetry(() => import(/* webpackChunkName: "Localities" */ 'pages/Localities'));
const Benefits = lazyRetry(() => import(/* webpackChunkName: "Benefits" */ 'pages/Benefits'));
const Tyc = lazyRetry(() => import(/* webpackChunkName: "Tyc" */ 'pages/Tyc'));
const Information = lazyRetry(() => import(/* webpackChunkName: "Tyc" */ 'pages/Information'));
const Services = lazyRetry(() => import(/* webpackChunkName: "Services" */ 'pages/Services'));
const FrequentQuestions = lazyRetry(() => import(/* webpackChunkName: "FrequentQuestions" */ 'pages/FrequentQuestions'));
const SecurityAndPrivacy = lazyRetry(() => import(/* webpackChunkName: "SecurityAndPrivacy" */ 'pages/SecurityAndPrivacy'));
const CatalogInstitutional = lazyRetry(() => import(/* webpackChunkName: "CatalogInstitutional" */ 'pages/CatalogInstitutional'));
const Providers = lazyRetry(() => import(/* webpackChunkName: "Providers" */ 'pages/Providers'));
const Contest = lazyRetry(() => import(/* webpackChunkName: "Contest" */ 'pages/Contest'));
const Contact = lazyRetry(() => import(/* webpackChunkName: "Contact" */ 'pages/Contact'));
const Commitments = lazyRetry(() => import(/* webpackChunkName: "Commitments" */ 'pages/Commitments'));
const Offers = lazyRetry(() => import(/* webpackChunkName: "Offers" */ 'pages/Offers'));
const UserList = lazyRetry(() => import(/* webpackChunkName: "UserList" */ 'pages/UserList'));
const Cart = lazyRetry(() => import(/* webpackChunkName: "Cart" */ 'pages/Cart'));
const Checkout = lazyRetry(() => import(/* webpackChunkName: "Checkout" */ 'pages/Checkout'));
const CheckoutDelivery = lazyRetry(() => import(/* webpackChunkName: "Checkout" */ 'pages/CheckoutDelivery'));
const Success = lazyRetry(() => import(/* webpackChunkName: "Success" */ 'pages/Success'));
const OrderStatus = lazyRetry(() => import(/* webpackChunkName: "OrderStatus" */ 'pages/OrderStatus'));
const School = lazyRetry(() => import(/* webpackChunkName: "School" */ 'pages/School'));
const NewOffer = lazyRetry(() => import(/* webpackChunkName: "NewOffer" */ 'pages/NewOffer'));
const AccountUser = lazyRetry(() => import(/* webpackChunkName: "AccountUser" */ 'pages/AccountUser'));
const AccountOrders = lazyRetry(() => import(/* webpackChunkName: "AccountOrders" */ 'pages/AccountOrders'));
const AccountList = lazyRetry(() => import(/* webpackChunkName: "AccountList" */ 'pages/AccountList'));
const OrderDetail = lazyRetry(() => import(/* webpackChunkName: "OrderDetail" */ 'pages/OrderDetail'));
const AccountCards = lazyRetry(() => import(/* webpackChunkName: "AccountCards" */ 'pages/AccountCards'));
const Login = lazyRetry(() => import(/* webpackChunkName: "AccountCards" */ 'pages/Login'));


import Error404 from 'pages/Error404';

const routes = [
    {
        path: "/",
        component: Home
    },
    {
        path: "/index.html",
        component: Home
    },
    {
        path: "/login",
        component: Home
    },
    {
        path: "/register",
        component: Home
    },
    {
        path: "/_secure/cart",
        component: Cart
    },
    {
        path: "/_secure/cart/upselling",
        component: Cart
    },
    {
        path: "/_secure/order/status/:orderId",
        component: OrderStatus
    },
    {
        path: "/_secure/orderDetail/:orderId",
        component: OrderDetail
    },
    {
        path: "/checkout",
        component: Checkout
    },
    {
        path: "/checkout/orderPlaced",
        component: Success
    },
    {
        path: "/checkout/split-delivery",
        component: CheckoutDelivery
    },
    {
        path: "/checkout/split-delivery/:index",
        component: CheckoutDelivery
    },
    {
        path: "/checkout/:slug",
        component: Checkout
    },
    {
        path: "/checkout/:slug/resume",
        component: Checkout
    },
    {
        path: "/:slug/p",
        component: Product
    },
    {
        path: "/Sistema/buscavazia",
        component: Error404
    },
    {
        path: "/Sistema/404",
        component: Error404
    },
    {
        path: "/institucional/locales-jumbo",
        component: Localities
    },
    {
        path: "/institucional/beneficios",
        component: Benefits
    },
    {
        path: "/institucional/servicios",
        component: Services
    },
    {
        path: "/institucional/terminos-condiciones",
        component: Tyc
    },
    {
        path: "/institucional/seguridad-privacidad",
        component: SecurityAndPrivacy
    },
    {
        path: "/institucional/preguntas-frecuentes/:slug",
        component: FrequentQuestions
    },
    {
        path: "/institucional/preguntas-frecuentes",
        component: FrequentQuestions
    },
    {
        path: "/institucional/concursos",
        component: Contest
    },
    {
        path: "/institucional/catalogos",
        component: CatalogInstitutional
    },
    {
        path: "/institucional/contacto",
        component: Contact
    },
    {
        path: "/institucional/proveedores",
        component: Providers
    },
    {
        path: "/institucional/compromisos",
        component: Commitments
    },
    {
        path: "/informaciones/:slug",
        component: Information
    },
    {
        path: "/informaciones",
        component: Information
    },
    {
        path: "/lista-de-compra",
        component: UserList
    },
    {
        path: "/_secure/account",
        component: AccountUser
    },
    {
        path: "/_secure/compras",
        component: AccountOrders
    },
    {
        path: "/_secure/listas-de-compras",
        component: AccountList
    },
    {
        path: "/mis-tarjetas",
        component: AccountCards
    },
    {
        path: "/ofertas",
        component: Offers
    },
    {
        path: "/oferta/:slug",
        component: NewOffer
    },
    {
        path: "/busca",
        component: Catalog
    },
    {
        path: "/escolares",
        component: School
    },
    {
        path: "/escolares/:Id",
        component: School
    },
    {
        path: "/login-page",
        component: Login
    },
    {
        path: "/:category1/:category2?/:category3?",
        component: Catalog
    },

];

export {
    routes,
    Error404
};
